import React from "react";
import { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { motion } from "framer-motion"
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Autoplay, Navigation, Keyboard } from 'swiper/modules';
import { Parallax, useParallax } from 'react-scroll-parallax';
import '../assets/css/team-slider.css';
import '../assets/css/services-slider.css';
import { Link } from "react-router-dom";

const Home = () => {

  const [selectedIndustry, setSelectedIndustry] = useState("All");
  const [selectedService, setSelectedService] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);





  const sliderImages = [
    {
      id: 1,
      url: require('../assets/images/banner-1.jpg'),
      title: "Building trust",
      subtitle: " Delivering excellence",
      description: "Delivering excellence through collaboration and innovation"
    },
    {
      id: 2,
      url: require('../assets/images/banner-2.jpg'),
      title: "Collaborative Teams",
      subtitle: " Driving Success",
      description: "Expert developers working together to deliver excellence"
    },
    {
      id: 3,
      url: require('../assets/images/banner-3.jpg'),
      title: "Strategic Planning",
      subtitle: "Agile Methodologies",
      description: "Agile methodologies driving project success"
    },
  ];
  const [active, setActive] = useState("marketing");


  return (
    <>

      {/* Hero Section */}
      <section className="hero-section" style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${require('../assets/images/banner.jpg')})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '400px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '100px 20px',
        textAlign: 'center'
      }}>
        <div className="container">
          <h1 style={{
            color: '#ffffff',
            fontSize: 'clamp(2.5rem, 5vw, 4rem)',
            fontWeight: '700',
            marginBottom: '20px',
            fontFamily: 'system-ui, -apple-system, sans-serif'
          }}>
            Professional Home Tuition For Class 6–10
          </h1>
          <p style={{
            color: '#ffffff',
            fontSize: 'clamp(1rem, 2vw, 1.25rem)',
            marginBottom: '40px',
            opacity: '0.9'
          }}>
            Special tutor for class 9 and 10 • All Subjects • Personal Attention
          </p>
          <a href="tel:+91 6392124790" style={{
            backgroundColor: '#FFC107',
            color: '#000000',
            padding: '15px 40px',
            borderRadius: '8px',
            fontSize: '1.2rem',
            fontWeight: '600',
            textDecoration: 'none',
            display: 'inline-block',
            transition: 'background-color 0.3s ease'
          }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#FFD54F'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#FFC107'}
          >
            Call Now
          </a>
        </div>
      </section>

      {/* New Online/Offline Classes Section */}
      <section className="classes-section py-5" style={{ backgroundColor: '#ffffff', overflow: 'hidden', marginTop: '20px' }}>
        <div className="container py-5">
          <div className="row align-items-center g-5">
            {/* Left Content */}
            <div className="col-lg-5 text-center text-lg-start">
              <span style={{ color: '#0d6efd', fontWeight: '700', letterSpacing: '1px', fontSize: '0.9rem', textTransform: 'uppercase' }}>
                Online & Offline Classes
              </span>
              <h2 style={{
                fontSize: 'clamp(2.5rem, 4vw, 3.5rem)',
                fontWeight: '800',
                color: '#1a1a1a',
                marginTop: '15px',
                marginBottom: '20px',
                fontFamily: 'system-ui, -apple-system, sans-serif',
                lineHeight: '1.2'
              }}>
                Learn Your Way, <br />
                <span style={{ color: '#0d6efd' }}>Online</span> or <span style={{ color: '#0d6efd' }}>Offline</span>
              </h2>
              <p style={{ color: '#666', fontSize: '1.1rem', marginBottom: '40px', lineHeight: '1.6', maxWidth: '100%' }}>
                We offer high-quality education through interactive online classes and engaging offline sessions.
              </p>

              <div className="d-flex flex-column flex-sm-row gap-4 mb-5 justify-content-center justify-content-lg-start">
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '15px', textAlign: 'left' }}>
                  <div style={{ backgroundColor: '#f5f8ff', padding: '15px', borderRadius: '12px', color: '#0d6efd', minWidth: '54px', textAlign: 'center' }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line></svg>
                  </div>
                  <div>
                    <h5 style={{ fontWeight: '700', fontSize: '1.1rem', marginBottom: '5px' }}>Online Classes</h5>
                    <p style={{ color: '#666', fontSize: '0.9rem', margin: 0 }}>Learn from anywhere with live interactive sessions.</p>
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '15px', textAlign: 'left' }}>
                  <div style={{ backgroundColor: '#f5f8ff', padding: '15px', borderRadius: '12px', color: '#0d6efd', minWidth: '54px', textAlign: 'center' }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                  </div>
                  <div>
                    <h5 style={{ fontWeight: '700', fontSize: '1.1rem', marginBottom: '5px' }}>Offline Classes</h5>
                    <p style={{ color: '#666', fontSize: '0.9rem', margin: 0 }}>Join engaging in-person classes and activities.</p>
                  </div>
                </div>
              </div>

              <div className="d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start gap-4">
                <button style={{ backgroundColor: '#002B7F', color: '#fff', border: 'none', padding: '12px 30px', borderRadius: '8px', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  Explore Courses <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14m-7-7 7 7-7 7" /></svg>
                </button>
                <button style={{ backgroundColor: 'transparent', color: '#1a1a1a', border: 'none', padding: '12px 0', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  Learn More <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14m-7-7 7 7-7 7" /></svg>
                </button>
              </div>
            </div>

            {/* Right Image/Graphic Collage */}
            <div className="col-lg-7 position-relative mt-5 mt-lg-0 px-4 px-lg-2">
              <div style={{ position: 'relative', paddingLeft: '1rem', paddingBottom: '30px', maxWidth: '600px', margin: '0 auto' }}>
                {/* Blue Background Circle */}
                <div style={{ position: 'absolute', top: '-10%', right: '5%', width: '85%', paddingBottom: '85%', backgroundColor: '#0d6efd', borderRadius: '50%', zIndex: 0 }}></div>

                {/* Dotted pattern placeholder element */}
                <div style={{ position: 'absolute', top: '-5%', right: '0', width: '100px', height: '100px', backgroundImage: 'radial-gradient(#ccc 2px, transparent 2px)', backgroundSize: '15px 15px', zIndex: 0 }}></div>

                {/* Main Image Base */}
                <img src={require('../assets/images/about.jpg')} alt="Student learning" style={{ width: '100%', borderRadius: '20px', position: 'relative', zIndex: 1, boxShadow: '0 20px 40px rgba(0,0,0,0.1)' }} />

                {/* Floating Card 1 */}
                <div className="d-none d-sm-block" style={{ position: 'absolute', top: '15%', left: '0', backgroundColor: '#fff', padding: '15px', borderRadius: '15px', boxShadow: '0 15px 30px rgba(0,0,0,0.1)', zIndex: 2, maxWidth: '200px', width: '50%' }}>
                  <div style={{ backgroundColor: '#0d6efd', color: '#fff', width: '35px', height: '35px', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '10px' }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line></svg>
                  </div>
                  <h6 style={{ fontWeight: '700', marginBottom: '8px', fontSize: '0.9rem' }}>Live Online Class</h6>
                  <p style={{ fontSize: '0.75rem', color: '#666', marginBottom: '10px' }}>Join live interactive sessions and learn.</p>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '0.75rem', fontWeight: '600', color: '#1a1a1a' }}>
                    <span style={{ width: '6px', height: '6px', backgroundColor: '#0d6efd', borderRadius: '50%' }}></span> Live Now
                  </div>
                </div>
                <div className="d-block d-sm-none" style={{ position: 'absolute', top: '10%', left: '-5%', backgroundColor: '#fff', padding: '10px', borderRadius: '10px', boxShadow: '0 5px 15px rgba(0,0,0,0.1)', zIndex: 2, display: 'flex', gap: '10px', alignItems: 'center' }}>
                  <div style={{ backgroundColor: '#0d6efd', color: '#fff', width: '30px', height: '30px', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line></svg>
                  </div>
                  <div>
                    <h6 style={{ fontWeight: '700', marginBottom: '2px', fontSize: '0.8rem', whiteSpace: 'nowrap' }}>Live Online Class</h6>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '0.65rem', fontWeight: '600', color: '#1a1a1a' }}>
                      <span style={{ width: '5px', height: '5px', backgroundColor: '#0d6efd', borderRadius: '50%' }}></span> Live Now
                    </div>
                  </div>
                </div>

                {/* Floating Card 2 */}
                <div className="d-none d-sm-block" style={{ position: 'absolute', bottom: '10%', right: '-5%', backgroundColor: '#fff', padding: '15px', borderRadius: '15px', boxShadow: '0 15px 30px rgba(0,0,0,0.1)', zIndex: 2, maxWidth: '200px', width: '50%' }}>
                  <div style={{ backgroundColor: '#0d6efd', color: '#fff', width: '35px', height: '35px', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '10px' }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                  </div>
                  <h6 style={{ fontWeight: '700', marginBottom: '8px', fontSize: '0.9rem' }}>Offline Class</h6>
                  <p style={{ fontSize: '0.75rem', color: '#666', marginBottom: '10px' }}>Attend offline classes for attention.</p>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '0.75rem', fontWeight: '600', color: '#1a1a1a' }}>
                    <span style={{ width: '6px', height: '6px', backgroundColor: '#0d6efd', borderRadius: '50%' }}></span> Join Now
                  </div>
                </div>
                <div className="d-block d-sm-none" style={{ position: 'absolute', bottom: '5%', right: '-5%', backgroundColor: '#fff', padding: '10px', borderRadius: '10px', boxShadow: '0 5px 15px rgba(0,0,0,0.1)', zIndex: 2, display: 'flex', gap: '10px', alignItems: 'center' }}>
                  <div style={{ backgroundColor: '#0d6efd', color: '#fff', width: '30px', height: '30px', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                  </div>
                  <div>
                    <h6 style={{ fontWeight: '700', marginBottom: '2px', fontSize: '0.8rem', whiteSpace: 'nowrap' }}>Offline Class</h6>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '0.65rem', fontWeight: '600', color: '#1a1a1a' }}>
                      <span style={{ width: '5px', height: '5px', backgroundColor: '#0d6efd', borderRadius: '50%' }}></span> Join Now
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Bottom Row */}
      <section style={{ padding: '60px 0' }}>
        <div className="container">
          <div className="row g-4 text-center text-sm-start" style={{
            backgroundColor: '#011e40',
            borderRadius: '15px',
            padding: '40px 20px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
          }}>
            <div className="col-12 col-sm-6 col-lg-3 d-flex flex-column flex-sm-row align-items-center align-items-sm-start justify-content-center justify-content-sm-start gap-3">
              <div style={{ color: '#fff', minWidth: '32px' }}>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 10v6M2 10l10-5 10 5-10 5z" /><path d="M6 12v5c3 3 9 3 12 0v-5" /></svg>
              </div>
              <div className="text-center text-sm-start">
                <h6 style={{ fontWeight: '700', color: '#fff', marginBottom: '5px' }}>Expert Teachers</h6>
                <p style={{ fontSize: '0.85rem', color: '#cbd5e1', margin: 0 }}>Learn from highly qualified and experienced educators.</p>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-lg-3 d-flex flex-column flex-sm-row align-items-center align-items-sm-start justify-content-center justify-content-sm-start gap-3 border-sm-start py-3 py-sm-0" style={{ borderLeft: '1px solid rgba(255,255,255,0.2)' }}>
              <div style={{ color: '#fff', minWidth: '32px' }}>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20" /></svg>
              </div>
              <div className="text-center text-sm-start">
                <h6 style={{ fontWeight: '700', color: '#fff', marginBottom: '5px' }}>Quality Education</h6>
                <p style={{ fontSize: '0.85rem', color: '#cbd5e1', margin: 0 }}>Comprehensive learning materials and resources.</p>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-lg-3 d-flex flex-column flex-sm-row align-items-center align-items-sm-start justify-content-center justify-content-sm-start gap-3 border-sm-start py-3 py-sm-0" style={{ borderLeft: '1px solid rgba(255,255,255,0.2)' }}>
              <div style={{ color: '#fff', minWidth: '32px' }}>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>
              </div>
              <div className="text-center text-sm-start">
                <h6 style={{ fontWeight: '700', color: '#fff', marginBottom: '5px' }}>Flexible Learning</h6>
                <p style={{ fontSize: '0.85rem', color: '#cbd5e1', margin: 0 }}>Choose online or offline classes as per your convenience.</p>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-lg-3 d-flex flex-column flex-sm-row align-items-center align-items-sm-start justify-content-center justify-content-sm-start gap-3 border-sm-start py-3 py-sm-0" style={{ borderLeft: '1px solid rgba(255,255,255,0.2)' }}>
              <div style={{ color: '#fff', minWidth: '32px' }}>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18" /><polyline points="17 6 23 6 23 12" /></svg>
              </div>
              <div className="text-center text-sm-start">
                <h6 style={{ fontWeight: '700', color: '#fff', marginBottom: '5px' }}>Better Results</h6>
                <p style={{ fontSize: '0.85rem', color: '#cbd5e1', margin: 0 }}>Focused learning that helps you achieve your goals.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Us Section */}
      <section className="about-section py-5" style={{ backgroundColor: '#f9f9f9' }}>
        <div className="container py-4">
          <div className="row align-items-center g-5">
            {/* Left Image Column */}
            <div className="col-lg-6">
              <div style={{
                borderRadius: '15px',
                overflow: 'hidden',
                boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                position: 'relative'
              }}>
                <img
                  src={require('../assets/images/about.jpg')}
                  alt="About The Study Home Tutorial"
                  style={{ width: '100%', height: '400px', objectFit: 'cover', display: 'block' }}
                />
              </div>
            </div>

            {/* Right Content Column */}
            <div className="col-lg-6">
              <div className="about-content p-4">
                <h2 style={{
                  fontSize: '2.5rem',
                  fontWeight: '700',
                  color: '#002B7F',
                  marginBottom: '20px',
                  fontFamily: 'system-ui, -apple-system, sans-serif',
                  textAlign: 'left'
                }}>
                  About Us
                </h2>
                <div style={{
                  width: '60px',
                  height: '4px',
                  backgroundColor: '#FFC107',
                  marginBottom: '30px'
                }}></div>
                <p style={{
                  fontSize: '1.2rem',
                  color: '#444',
                  lineHeight: '1.8',
                  marginBottom: '20px'
                }}>
                  The Study Home Tutorial provides quality home tuition for students from Class 6 to 10. We focus on concept clarity, personal attention, regular tests, and better academic results.
                </p>

                <ul style={{
                  listStyle: 'none',
                  padding: 0,
                  marginTop: '30px'
                }}>
                  {['Concept Clarity', 'Personal Attention', 'Regular Tests', 'Better Results'].map((item, index) => (
                    <li key={index} style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: '15px',
                      fontSize: '1.1rem',
                      color: '#333',
                      fontWeight: '500'
                    }}>
                      <span style={{
                        color: '#002B7F',
                        marginRight: '15px',
                        fontSize: '1.5rem'
                      }}>✓</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section py-5" style={{ backgroundColor: '#f0f4f8' }}>
        <div className="container py-4">
          <div className="mb-5">
            <h2 style={{ fontSize: '2.5rem', fontWeight: '700', color: '#002B7F', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
              Our Services
            </h2>
          </div>

          <div className="row g-4">
            {/* Service 1 */}
            <div className="col-md-6 col-lg-4">
              <motion.div
                whileHover={{ y: -10 }}
                style={{
                  backgroundColor: '#ffffff',
                  borderRadius: '16px',
                  padding: '40px 30px',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                  height: '100%',
                  transition: 'box-shadow 0.3s ease'
                }}
              >
                <div style={{
                  width: '70px',
                  height: '70px',
                  borderRadius: '50%',
                  backgroundColor: '#e6f0ff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '25px',
                  color: '#002B7F',
                  fontSize: '30px'
                }}>
                  📚
                </div>
                <h3 style={{ fontSize: '1.5rem', fontWeight: '600', color: '#1a1a1a', marginBottom: '15px' }}>
                  All Subjects
                </h3>
                <p style={{ color: '#555', fontSize: '1.05rem', lineHeight: '1.6', margin: 0 }}>
                  Maths, Science, English, Hindi and more. Comprehensive coverage of syllabus.
                </p>
              </motion.div>
            </div>

            {/* Service 2 */}
            <div className="col-md-6 col-lg-4">
              <motion.div
                whileHover={{ y: -10 }}
                style={{
                  backgroundColor: '#ffffff',
                  borderRadius: '16px',
                  padding: '40px 30px',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                  height: '100%',
                  transition: 'box-shadow 0.3s ease'
                }}
              >
                <div style={{
                  width: '70px',
                  height: '70px',
                  borderRadius: '50%',
                  backgroundColor: '#fff4e6',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '25px',
                  color: '#ff9800',
                  fontSize: '30px'
                }}>
                  🎯
                </div>
                <h3 style={{ fontSize: '1.5rem', fontWeight: '600', color: '#1a1a1a', marginBottom: '15px' }}>
                  Personal Attention
                </h3>
                <p style={{ color: '#555', fontSize: '1.05rem', lineHeight: '1.6', margin: 0 }}>
                  Individual focus to identify strengths and weaknesses for better academic performance.
                </p>
              </motion.div>
            </div>

            {/* Service 3 */}
            <div className="col-md-6 col-lg-4">
              <motion.div
                whileHover={{ y: -10 }}
                style={{
                  backgroundColor: '#ffffff',
                  borderRadius: '16px',
                  padding: '40px 30px',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                  height: '100%',
                  transition: 'box-shadow 0.3s ease'
                }}
              >
                <div style={{
                  width: '70px',
                  height: '70px',
                  borderRadius: '50%',
                  backgroundColor: '#e6ffe6',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '25px',
                  color: '#4caf50',
                  fontSize: '30px'
                }}>
                  🏠
                </div>
                <h3 style={{ fontSize: '1.5rem', fontWeight: '600', color: '#1a1a1a', marginBottom: '15px' }}>
                  Home Tuition
                </h3>
                <p style={{ color: '#555', fontSize: '1.05rem', lineHeight: '1.6', margin: 0 }}>
                  A safe, comfortable, and personalized learning experience right at your home.
                </p>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* Classes We Teach Section */}
      <section className="classes-section py-5" style={{ backgroundColor: '#f5f7fa' }}>
        <div className="container py-4">
          <div className="mb-5">
            <h2 style={{ fontSize: '2.5rem', fontWeight: '700', color: '#1a1a1a', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
              Classes We Teach
            </h2>
          </div>

          <div className="row g-4">
            {[6, 7, 8, 9, 10].map((classNum) => (
              <div key={classNum} className="col-12 col-sm-6 col-md-4 col-lg-3">
                <motion.div
                  whileHover={{
                    y: -5,
                    boxShadow: '0 15px 35px rgba(0, 0, 0, 0.1)'
                  }}
                  style={{
                    backgroundColor: '#ffffff',
                    borderRadius: '12px',
                    padding: '35px 25px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.04)',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    height: '100%',
                    borderLeft: '4px solid #FFC107'
                  }}
                >
                  <h3 style={{
                    fontSize: '1.4rem',
                    fontWeight: '700',
                    color: '#002B7F',
                    margin: 0,
                    display: 'flex',
                    alignItems: 'center',
                    gap: '15px'
                  }}>
                    <span style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '40px',
                      height: '40px',
                      background: '#f0f4f8',
                      borderRadius: '50%',
                      fontSize: '1.2rem'
                    }}>
                      📘
                    </span>
                    Class {classNum}
                  </h3>
                </motion.div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Client Results Snapshot Section */}
      <section className="client-results-section py-5" style={{ backgroundColor: '#ffffff' }}>
        <div className="container">
          <div className="text-center mb-5">
            <h2 style={{ fontWeight: 'bold', color: '#333', fontSize: '2.5rem' }}>
              Results Snapshot
            </h2>
            <p style={{ color: '#666', fontSize: '1rem', maxWidth: '800px', margin: '0 auto' }}>
              A glimpse into the success stories and improved academic performances of our students.
            </p>
          </div>

          <div className="row g-4 justify-content-center">
            {/* Result Card 1 */}
            <div className="col-md-6 col-lg-3">
              <div className="result-card text-center d-flex flex-column justify-content-center align-items-center" style={{ padding: '40px 20px', borderRadius: '16px', backgroundColor: '#fafcfb', boxShadow: '0 10px 30px rgba(0,0,0,0.05)', transition: 'all 0.3s ease', minHeight: '220px', border: '1px solid #f0f0f0' }}
                onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-8px)'; e.currentTarget.style.boxShadow = '0 15px 40px rgba(0,0,0,0.08)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.05)'; }}>
                <div style={{ fontSize: '2.5rem', color: '#4caf50', marginBottom: '20px' }}>
                  <i className="fas fa-graduation-cap"></i>
                </div>
                <h4 style={{ fontSize: '2rem', fontWeight: '700', marginBottom: '8px', color: '#222' }}>
                  95%
                </h4>
                <p style={{ color: '#666', fontSize: '0.95rem', marginBottom: '0', fontWeight: '500' }}>
                  Satisfaction Rate
                </p>
              </div>
            </div>

            {/* Result Card 2 */}
            <div className="col-md-6 col-lg-3">
              <div className="result-card text-center d-flex flex-column justify-content-center align-items-center" style={{ padding: '40px 20px', borderRadius: '16px', backgroundColor: '#fafcfb', boxShadow: '0 10px 30px rgba(0,0,0,0.05)', transition: 'all 0.3s ease', minHeight: '220px', border: '1px solid #f0f0f0' }}
                onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-8px)'; e.currentTarget.style.boxShadow = '0 15px 40px rgba(0,0,0,0.08)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.05)'; }}>
                <div style={{ fontSize: '2.5rem', color: '#2196f3', marginBottom: '20px' }}>
                  <i className="fas fa-chart-line"></i>
                </div>
                <h4 style={{ fontSize: '2rem', fontWeight: '700', marginBottom: '8px', color: '#222' }}>
                  30%
                </h4>
                <p style={{ color: '#666', fontSize: '0.95rem', marginBottom: '0', fontWeight: '500' }}>
                  Average Improvement
                </p>
              </div>
            </div>

            {/* Result Card 3 */}
            <div className="col-md-6 col-lg-3">
              <div className="result-card text-center d-flex flex-column justify-content-center align-items-center" style={{ padding: '40px 20px', borderRadius: '16px', backgroundColor: '#fafcfb', boxShadow: '0 10px 30px rgba(0,0,0,0.05)', transition: 'all 0.3s ease', minHeight: '220px', border: '1px solid #f0f0f0' }}
                onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-8px)'; e.currentTarget.style.boxShadow = '0 15px 40px rgba(0,0,0,0.08)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.05)'; }}>
                <div style={{ fontSize: '2.5rem', color: '#f44336', marginBottom: '20px' }}>
                  <i className="fas fa-user-graduate"></i>
                </div>
                <h4 style={{ fontSize: '2rem', fontWeight: '700', marginBottom: '8px', color: '#222' }}>
                  1200+
                </h4>
                <p style={{ color: '#666', fontSize: '0.95rem', marginBottom: '0', fontWeight: '500' }}>
                  Students Enrolled
                </p>
              </div>
            </div>

            {/* Result Card 4 */}
            <div className="col-md-6 col-lg-3">
              <div className="result-card text-center d-flex flex-column justify-content-center align-items-center" style={{ padding: '40px 20px', borderRadius: '16px', backgroundColor: '#fafcfb', boxShadow: '0 10px 30px rgba(0,0,0,0.05)', transition: 'all 0.3s ease', minHeight: '220px', border: '1px solid #f0f0f0' }}
                onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-8px)'; e.currentTarget.style.boxShadow = '0 15px 40px rgba(0,0,0,0.08)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.05)'; }}>
                <div style={{ fontSize: '2.5rem', color: '#9c27b0', marginBottom: '20px' }}>
                  <i className="fas fa-comments"></i>
                </div>
                <h4 style={{ fontSize: '2rem', fontWeight: '700', marginBottom: '8px', color: '#222' }}>
                  300+
                </h4>
                <p style={{ color: '#666', fontSize: '0.95rem', marginBottom: '0', fontWeight: '500' }}>
                  Positive Reviews
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
